<template>
  <div class="task-main-detail">
    <div class="task-main-detail__header">
      <template v-if="isEstimate">
        <div class="task-main-detail__header_estimate">
          Оценка задачи
          <TirPmButton
            :variant="TirPmButtonVariantEnum.LinkState"
            :size="TirPmButtonSizeEnum.Regular"
            @click="closeEstimate"
          >
            <template #leftSlot>
              <CrossCompactIcon />
            </template>
          </TirPmButton>
        </div>
      </template>
      <template v-else>
        <TirPmButton
          class="task-main-detail__arrow-uturn-left-icon"
          :size="TirPmButtonSizeEnum.Regular"
          :variant="TirPmButtonVariantEnum.LinkState"
          @click="goBack"
        >
          <template #leftSlot>
            <ArrowUturnLeftIcon />
          </template>
        </TirPmButton>
        <TaskMorePopover
          v-if="isEditMode"
          :userAccess="userAccess"
          :task="editTaskInfo"
          :task-id="editTaskInfo.Id"
          :project-id="editTaskInfo.ProjectId"
          :task-name="editTaskInfo.Name"
          :isParentalTask="!!editTaskInfo.Parent"
          :attachedQueues="!!editTaskInfo.QueueToTaskRelationList?.length"
          :subtasks="subtasks"
          :isSubtasks="!!editTaskInfo?.SubtaskCount"
          :timerTrackerRecords="timerTrackerRecords"
          :parent-task-id="editTaskInfo.Parent?.Id"
          :search-tasks-function="searchTasksChangeParent"
          :is-loading-unattach-button="isLoadingUnattachParent"
          :custom-position="{
            left: '0rem',
            top: '$el:height + 0.25rem',
          }"
          :editing="editing"
          :show-remove="userAccess.IsProjectAdmin || userAccess.IsOwner"
          @attach-parent-task="emit('attachParentTask', $event)"
          @change-parent-task="emit('changeParentTask', $event)"
          @unattach-parent-task="emit('unattachParentTask')"
          @copy-task-link="emit('copyTaskLink')"
          @successRemove="goBack"
        >
          <TirPmButton
            :variant="TirPmButtonVariantEnum.LinkState"
            :size="TirPmButtonSizeEnum.Regular"
          >
            <template #leftSlot>
              <EllipsisHorizontalIcon />
            </template>
          </TirPmButton>
        </TaskMorePopover>
        <TaskParentView
          v-if="editTaskInfo?.Parent"
          :parent-task="editTaskInfo.Parent"
          :is-loading-unattach="isLoadingUnattachParent"
          @unattach="emit('unattachParentTask')"
        />
      </template>
    </div>
    <TirDivider v-if="editTaskInfo?.Parent" />
    <div class="task-main-detail__subheader">
      <div class="task-main-detail__subheader-left">
        <div class="task-main-detail__subheader-info">
          <TirPmButton
            v-if="!isEditMode"
            :size="TirPmButtonSizeEnum.Small"
            :variant="TirPmButtonVariantEnum.PrimaryState"
            :is-disabled="isDisableCreateButton"
            :is-loading="isLoadingCreateButton"
            @click="emit('onClickCreate')"
          >
            Создать
          </TirPmButton>
          <div
            v-if="editTaskInfo?.Id"
            :class="['task-main-detail__author', { 'is-have-id': !!editTaskInfo?.Id }]"
            @click="emit('copyId')"
          >
            <TirPmTooltipElement>
              <template #default>
                <TirPmIconView
                  :size="24"
                  isRounded
                  :isBordered="false"
                  :colorCode="editTaskInfo?.Owner?.AvatarColor"
                  :imageLoadUrl="editTaskInfo?.Owner?.Photo"
                >
                  <template #mainSlot>
                    {{ computedNameFotoCurrentUser }}
                  </template>
                </TirPmIconView>
              </template>
              <template #content>
                <p class="task-main-detail__tooltip-text">
                  {{ editTaskInfo.Owner.LastName }} {{ editTaskInfo.Owner.FirstName }}
                  {{ editTaskInfo.Owner.MiddleName }}
                </p>
              </template>
            </TirPmTooltipElement>
            <span class="task-main-detail__author-id" v-if="editTaskInfo?.Id">
              {{ editTaskInfo.Id }}
            </span>
          </div>
          <WeeekTag
            v-if="editTaskInfo?.WeeekTask"
            class="task-main-detail__weeek-tag"
            :href="weeekTaskUrl"
          />
          <TirPmTooltipElement>
            <TirPmButton
              v-if="editTaskInfo?.Id"
              class="task-main-detail__copy-button"
              :size="TirPmButtonSizeEnum.Small"
              :variant="TirPmButtonVariantEnum.LinkState"
              @click="copyTaskLink"
            >
              <template #leftSlot>
                <LinkIcon />
              </template>
            </TirPmButton>
            <template #content>Скопировать ссылку</template>
          </TirPmTooltipElement>
          <div class="task-main-detail__subheader-description">{{ title }}</div>
        </div>
        <div
          v-if="subtasks.length || editTaskInfo?.QueueToTaskRelationList?.length"
          class="task-main-detail__count-subtasks"
          @click="scrollToElementTop($subtasks)"
        >
          Дочерние тикеты/очереди: {{ subtasks.length }}/{{
            editTaskInfo?.QueueToTaskRelationList?.length
          }}
        </div>
      </div>
    </div>
    <TirPmScrollbar ref="$scrollbar" class="task-main-detail__scroll" :show-on-hover="true">
      <div class="task-main-detail__input-wrap">
        <TaskInputName
          :isDisabled="!isEditMode || !editing"
          :model-value="formData.Name"
          placeholder="Введите название задачи"
          :error-message="errors?.Name"
          no-x-padding
          v-model:mode="inputMode"
          @update:modelValue="updateTaskName"
          @copy-name="emit('copyName')"
          :editing="editing"
        />
      </div>
      <div class="task-main-detail__tags">
        <TaskTagsSelect
          :model-value="formData.Tags"
          :options="tags"
          :editing="editing"
          @update:model-value="emit('saveTaskTags', $event)"
        />
      </div>
      <TirPmTextEditorFile
        v-if="descriptionIsEditMode && editing"
        ref="$editor"
        class="task-main-detail__editor"
        :model-value="formData.Description"
        label="Описание"
        :is-hide-main-controls="!isEditMode"
        :file-upload-callbak="fileUploadCallbak"
        :all-files="editorFiles"
        :files-loading-edit-name="filesLoadingEditName"
        :max-file-size="100000 * 1024 * 1024"
        :scrollArea="$wrapper"
        :header-height="57"
        @update:model-value="setValue('Description', $event)"
        @save="onClickSaveDescription"
        @cancel="onClickCancelSaveDescription"
        @on-click-delete-file="onRemoveFile($event as number, true)"
        @on-click-edit-file="emit('openEditImage', $event as number)"
        @save-file-name="emitUpdateFileName"
      />
      <TirPmTextEditorFilePreview
        v-else
        label="Описание"
        class="task-main-detail__editor"
        :content="formData.Description"
        :is-expand="isExpandDescription"
        :all-files="editorFileForPreview"
        :files-loading-edit-name="filesLoadingEditName"
        @to-edit="descriptionIsEditMode = true"
        @change-expand="isExpandDescription = !isExpandDescription"
        @on-click-delete-file="onRemoveFile($event as number, true)"
        @on-click-edit-file="emit('openEditImage', $event as number)"
        @save-file-name="emitUpdateFileName"
        :editing="editing"
      />
      <TirPmButton
        v-if="editing"
        :variant="TirPmButtonVariantEnum.LinkState"
        :size="TirPmButtonSizeEnum.Small"
        class="task-main-detail__editor-float-button"
        @click="descriptionIsEditMode = true"
        :class="{
          'task-main-detail__editor-float-button--show':
            isShowFloatButton && !descriptionIsEditMode,
        }"
      >
        <template #leftSlot>
          <PencilSquareIcon />
        </template>
      </TirPmButton>
      <div class="task-main-detail__users">
        <TaskEmployeeMultiselect
          :model-value="formData.PerformerIds"
          :employees="multiselectPerformers"
          label="Исполнители"
          :editing="editing"
          @update:model-value="emit('saveTaskPerformers', $event)"
        />
        <div class="task-main-detail__users-divider" />
        <TaskEmployeeMultiselect
          :model-value="formData.ObserverIds"
          :employees="multiselectObservers"
          label="Наблюдатели"
          :editing="editing"
          @update:model-value="emit('saveTaskObservers', $event)"
        />
      </div>
      <TirDivider style="margin: 1.5rem 0" />
      <div class="task-main-detail__files">
        <TaskFiles
          :files="files"
          :is-disabled="!isEditMode || !editing"
          :is-loading-attach-button="isLoadingAttachFilesButton"
          :files-loading-edit-name="filesLoadingEditName"
          @attach-files="emit('attachFiles', $event, false)"
          @remove-file="onRemoveFile($event, false)"
          @update-name="emitUpdateFileName"
          @open-edit-image="emit('openEditImage', $event)"
        />
      </div>
      <div ref="$subtasks">
        <TaskRelations
          ref="$taskRelations"
          v-if="editTaskInfo"
          :userAccess="userAccess"
          :taskId="editTaskInfo.Id"
          :projectId="editTaskInfo.ProjectId"
          :queueId="editTaskInfo.QueueTaskId"
          :subtasks="subtasks"
          :subtasksCount="editTaskInfo.SubtaskCount"
          :queues="editTaskInfo.QueueToTaskRelationList"
          :tasksSearchFunction="searchTasksToAttach"
          :isEdit="isEditMode && editing"
          @attachSubtask="attachSubtask"
          @attachQueue="attachQueue"
          @removeSubtask="emit('removeSubtask', $event)"
          @created-subtask="emit('createdSubtask', $event)"
          @updated-subtask="emit('updatedSubtask', $event)"
        />

        <div ref="$subtasksEndBlock" />
      </div>
      <TaskDialogModal ref="$dialogModal" />
    </TirPmScrollbar>
  </div>
</template>

<script lang="ts" setup>
import { computed, CSSProperties, nextTick, onMounted, PropType, Ref, ref, watch } from 'vue';
import { TaskModel, TaskFormDataModel } from './models';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirDivider,
  TirPmScrollbar,
  PopoverColorEnum,
  TirPmPopover,
  PopoverPositionEnum,
  TirPmTooltipElement,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
} from 'tir-components';
import {
  ArrowUturnLeftIcon,
  ClipboardDocumentIcon,
  PencilSquareIcon,
  EllipsisHorizontalIcon,
  CrossCompactIcon,
  LinkIcon,
} from 'tir-style-system/icons/outline';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import tirPmDateTransform from 'tir-pm-date-transform';
import {
  TaskInputName,
  TaskTagsSelect,
  TaskEmployeeMultiselect,
  SubtasksSearchFunctionType,
  TaskFiles,
  TaskInputNameModeEnum,
  TaskMorePopover,
  TaskParentView,
  TaskRelations,
  TaskDrawerSettingsModel,
  TimeTrackerRecordModel,
} from '../index';
import { TaskDetailErrors } from './types';
import { TagModel, UserModel, SubtaskModel, TaskFileModel } from '../../models';
import { useRoute, useRouter } from 'vue-router';
import {
  FileUploadCallbackFunctionType,
  ITextEditorFile,
  TirPmTextEditorFile,
  TirPmTextEditorFilePreview,
} from 'tir-pm-texteditor-file';
import { onUnmounted } from 'vue';
import { inject } from 'vue';
import { FilePreviewAccessEnum } from 'tir-pm-file-preview';
import { FileManager } from 'tir-pm-file-upload-manager';
import { WeeekTag } from '@/components/weeek-tag';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from './models/GetAccessCurrentUserInQueueTaskByIdResponseModel';
import { copyToClipboard } from '../../utils';
import { TaskDialogEnum, TaskDialogModal } from '../task-dialog-modal';
import { ComponentInstance } from 'tir-pm-toolkit';

const emit = defineEmits<{
  /**Событие обновления данных формы */
  (e: 'update:formData', value: TaskFormDataModel): void;
  /**Событие сохранения названия задачи */
  (e: 'saveTaskName'): void;
  /**Событие сохранения выбранных тегов задачи */
  (e: 'saveTaskTags', tags: Array<number>): void;
  /**Событие сохранение выбранных исполнителей */
  (e: 'saveTaskPerformers', performers: Array<number>): void;
  /**Событие сохранения выбранных наблюдателей */
  (e: 'saveTaskObservers', observers: Array<number>): void;
  /**Событие сохранения описания */
  (e: 'saveTaskDescription'): void;
  /**Событие раскрытия всех подзадач */
  (e: 'showAllSubtasks'): void;
  /**Событие удаления подзадачи */
  (e: 'removeSubtask', subtaskId: number): void;
  /**Событие добавления подзадачи */
  (e: 'attachSubtask', taskId: number): void;
  /**Событие клика по кнопке создания */
  (e: 'onClickCreate'): void;
  /**Событие прикрепления файлов */
  (e: 'attachFiles', files: Array<File>, fromDescription: boolean): void;
  /**Событие удаления файла */
  (e: 'removeFile', fileId: number, fromDescription: boolean): void;
  /**Событие обновления названия файла */
  (e: 'updateFileName', fileId: number, fileName: string): void;
  /**Событие для прикрепления родительской задачи */
  (e: 'attachParentTask', parentTaskId: number): void;
  /**Событие для открепления родительской задачи */
  (e: 'unattachParentTask'): void;
  /**Событие для смены родительской задачи */
  (e: 'changeParentTask', parentTaskId: number): void;
  /**Событие для копирования идентификатора задачи */
  (e: 'copyId'): void;
  /**Событие для копироваия названия задачи */
  (e: 'copyName'): void;
  /**Событие копирования ссылки на задачу */
  (e: 'copyTaskLink'): void;
  /**Событие открытия окна с редактированием изображения */
  (e: 'openEditImage', fileId: number): void;
  /**Создана подзадача */
  (e: 'createdSubtask', taskId: number): void;
  /**Обновлена подзадача */
  (e: 'updatedSubtask', taskId: number): void;
}>();

const emitUpdateFileName = (fileId: number, fileName: string) =>
  emit('updateFileName', fileId, fileName);

const props = defineProps({
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
  /**Записи таймера */
  timerTrackerRecords: {
    type: Array as PropType<Array<TimeTrackerRecordModel>>,
    default: [],
  },
  /**Данные задачи */
  task: {
    type: Object as PropType<TaskModel>,
    required: true,
  },
  /**Список загружаемых файлов */
  uploadingFiles: {
    type: Array as PropType<Array<TaskFileModel>>,
    default: [],
  },
  /**Список тегов */
  tags: {
    type: Array as PropType<Array<TagModel>>,
    default: [],
  },
  /**Список сотрудников */
  employees: {
    type: Array as PropType<Array<UserModel>>,
    default: [],
  },
  /**Список подзадач */
  subtasks: {
    type: Array as PropType<Array<SubtaskModel>>,
    default: [],
  },
  /**Редактируемая задача */
  editTaskInfo: {
    type: Object as PropType<TaskModel>,
  },
  /**Данные формы */
  formData: {
    type: Object as PropType<TaskFormDataModel>,
    required: true,
  },
  /**Ошибки */
  errors: {
    type: Object as PropType<TaskDetailErrors>,
  },
  /**Отобразить все подзадачи */
  isViewAllSubtasks: {
    type: Boolean,
    default: false,
  },
  /**Игнорируемы подзадачи при поиске */
  ignoreSearchSubtasks: {
    type: Array as PropType<Array<number>>,
    default: [],
  },
  /**Кол-во подзадач */
  countSubtasks: {
    type: Number,
    required: true,
  },
  /**Загрузка при показе всех подзадач */
  isLoadingShowAllSubtasks: {
    type: Boolean,
    default: false,
  },
  /**Функция поиска задач для добавляения */
  searchTasksToAttach: {
    type: Function as PropType<SubtasksSearchFunctionType>,
    required: true,
  },
  /**Функция поиска задач для смены родителя */
  searchTasksChangeParent: {
    type: Function as PropType<SubtasksSearchFunctionType>,
    required: true,
  },
  /**Функция для загрузки файла из описания */
  fileUploadCallbak: {
    type: Function as PropType<FileUploadCallbackFunctionType>,
    required: true,
  },
  /**Заблокировать кнопку создания */
  isDisableCreateButton: {
    type: Boolean,
    default: false,
  },
  /**Загрузка кнопки создания */
  isLoadingCreateButton: {
    type: Boolean,
    default: false,
  },
  /**Загрузка кнопки прикрепления файлов */
  isLoadingAttachFilesButton: {
    type: Boolean,
    default: false,
  },
  /**Загрузка при редактировании названия */
  filesLoadingEditName: {
    type: Array as PropType<Array<number>>,
    default: [],
  },
  /**Загрузка при откреплении родительской задачи */
  isLoadingUnattachParent: {
    type: Boolean,
    default: false,
  },
  /**Загрузка при откреплении родительской задачи */
  editing: {
    type: Boolean,
    default: true,
  },
  /**Загрузка при откреплении подзадач */
  isLoadingUnattachSubtask: {
    type: Set as PropType<Set<number>>,
    default: false,
  },
  /**Оценка задачи */
  isEstimate: { type: Boolean },
});
const router = useRouter();

/**Является ли текущий юзер овнером */
const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);

/**Элемент обертки */
const $wrapper = inject('wrapperElement') as Ref<HTMLDivElement>;
/**Ссылка на элемент редактора */
const $editor = ref<any>();

/**Ссылка на комненент с подзадачами */
const $subtasks = ref<HTMLElement>();
/**Ссылка на DOM конца блока подзадач */
const $subtasksEndBlock = ref<HTMLElement>();
/**Ссылка на компонент TaskRelations*/
const $taskRelations = ref<InstanceType<typeof TaskRelations>>();

/**Ссылка на скролл */
const $scrollbar = ref<InstanceType<typeof TirPmScrollbar>>();
/**Сссылка на компонент */
const $dialogModal = ref<ComponentInstance<typeof TaskDialogModal>>();

/**Ссылка на задачу weeek */
const weeekTaskUrl = computed(() =>
  props.editTaskInfo?.WeeekTask?.WeeekTaskId !== undefined &&
  props.editTaskInfo.WeeekTask?.WeeekWorkspaceId !== undefined
    ? `https://app.weeek.net/ws/${props.editTaskInfo.WeeekTask.WeeekWorkspaceId}/task/${props.editTaskInfo.WeeekTask.WeeekTaskId}`
    : undefined,
);

const authorTask = props.employees.find((e) => e.Id == props.editTaskInfo?.OwnerId);

const files = computed(() => {
  const formDataFiles = props.formData.Files.filter(
    (file) => !props.uploadingFiles.some((_uploadFile) => file.Id === _uploadFile.Id),
  );
  return [...formDataFiles, ...props.uploadingFiles];
});

const setValue = <T extends keyof TaskFormDataModel>(key: T, value: TaskFormDataModel[T]) => {
  const data = new TaskFormDataModel({
    ...props.formData,
    [key]: value,
  });
  emit('update:formData', data);
};

const updateTaskName = (value: string) => {
  setValue('Name', value);
  emit('saveTaskName');
};

/**Режим редактирования */
const isEditMode = computed(() => !!props.editTaskInfo);
/**Режим инпута */
const inputMode = ref(
  props.editTaskInfo ? TaskInputNameModeEnum.View : TaskInputNameModeEnum.Create,
);
/**Режим поля ввода описания */
const descriptionIsEditMode = ref(!props.editTaskInfo);
/**Раскрыто ли полностью описание */
const isExpandDescription = ref(false);
/**Предыдущее значение описания */
const previousDescription = ref<string>();

const computedNameFotoCurrentUser = computed(() => {
  return CurrentUser?.FirstName?.[0]?.toUpperCase() + CurrentUser?.LastName?.[0]?.toUpperCase();
});
/**Список исполнителей для мультиселекта */
const multiselectPerformers = computed(() =>
  props.editing ? props.employees : props.formData.Performers,
);
/**Список наблюдателей для мультиселекта */
const multiselectObservers = computed(() =>
  props.editing ? props.employees : props.formData.Observers,
);
/**Были ли сохранены изменения в описании */
const isChangedDescription = computed(
  () => previousDescription.value == props.formData.Description,
);

/**Заголовок */
const title = computed(() => {
  if (!isEditMode.value) return 'Новая задача';
  if (props.editTaskInfo?.DateCreate && props.editTaskInfo?.DateUpdate) {
    const dateCreate = props.editTaskInfo.DateCreate;
    const dateUpdate = props.editTaskInfo.DateUpdate;
    return `Создано ${tirPmDateTransform(dateCreate).format(
      'DD.MM.YYYY',
    )}, обновлено ${tirPmDateTransform(dateUpdate).format('DD.MM.YYYY')} в ${tirPmDateTransform(
      dateUpdate,
    ).format('HH:mm')}`;
  }
});

/** Скопировать короткую ссылку на задачу */
const copyTaskLink = async () => {
  if (!props.editTaskInfo.Id) return;

  const to = router.resolve({
    name: 'task-short-detail',
    params: {
      taskId: props.editTaskInfo.Id,
    },
  }).href;

  const origin =
    window.location.hostname === 'localhost' ? 'https://beta.hub-pm.com' : window.location.origin;

  const link = `${origin}${to}`;
  await copyToClipboard(link);
  addNotification('Ссылка на задачу скопирована');
};

const editorFiles = computed<Array<ITextEditorFile>>(() => {
  const a = files.value.map((file) => ({
    FileId: file.Id,
    Url: file.Url,
    VideoPreviewUrl: file.VideoPreviewUrl,
    Name: file.Name,
    Size: file.Size,
    DateUpload: file.DateUpload,
    Progress: file.UploadProgress,
    User: {
      Id: file.User.Id,
      FirstName: file.User.FirstName,
      LastName: file.User.LastName,
      MiddleName: file.User.MiddleName,
      AvatarColor: file.User.AvatarColor,
      Image: file.User.ImageUrl,
    },
    Accesses: file.IsSendingLastChunk
      ? []
      : [FilePreviewAccessEnum.Edit, FilePreviewAccessEnum.Remove],
    IsProccessing: file.IsProccessing,
  }));
  return a;
});

const editorFileForPreview = computed(() =>
  editorFiles.value.map((file) => ({
    ...file,
    Accesses: file.Accesses?.length ? [FilePreviewAccessEnum.Edit] : [],
  })),
);

watch(
  () => isEditMode.value,
  () => {
    if (isEditMode.value) {
      inputMode.value = TaskInputNameModeEnum.View;
    }
  },
);

const onRemoveFile = (fileId: number, fromDescription: boolean) => {
  const isUploadFile = props.uploadingFiles.some((file) => file.Id === fileId);
  if (isUploadFile) {
    FileManager.cancel({ FileId: fileId });
    return;
  }
  emit('removeFile', fileId, fromDescription);
};

/**Добавление подзадачи */
const attachSubtask = (value) => {
  emit('attachSubtask', value);
  setTimeout(() => {
    scrollToElementTop($subtasksEndBlock.value);
  }, 500);
};
/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'general',
      life: life ?? 2000,
      closable: true,
    }),
  );
};

/**При добавление очереди */
const attachQueue = () => {
  setTimeout(() => {
    scrollToElementTop($subtasksEndBlock.value);
  }, 500);
};

/**Спуститься до нужного контейнера */
const scrollToElementTop = (el: HTMLElement): void => {
  const scrollContainer = $scrollbar.value.$scroll;
  const currentScrollTop = scrollContainer.scrollTop;
  const targetScrollTop =
    currentScrollTop +
    el.getBoundingClientRect().top -
    scrollContainer.getBoundingClientRect().top -
    20;

  // Если текущая позиция совпадает с целевой, не прокручивать
  if (currentScrollTop === targetScrollTop) return;

  // Плавно прокручиваем контейнер
  scrollContainer.scrollTo({
    top: targetScrollTop,
    behavior: 'smooth',
  });
};

/**Открыт ли дропдаун поиска задач */
const isOpenedTaskSearchDropdown = ref(false);

/**Стили блока подзадач */
const subtasksElementStyle = computed<CSSProperties>(() => {
  let paddingBottom = 58;
  if (isOpenedTaskSearchDropdown.value) {
    paddingBottom += 273;
    paddingBottom -= 49.33 * props.subtasks.length;
    if (!props.isViewAllSubtasks && props.subtasks.length) paddingBottom -= 50;
  }
  return { paddingBottom: `${paddingBottom / 16}rem` };
});

const onClickSaveDescription = () => {
  emit('saveTaskDescription');
  if (isEditMode.value) {
    descriptionIsEditMode.value = false;
    previousDescription.value = props.formData.Description;
  }
};

const onClickCancelSaveDescription = async () => {
  if (!isChangedDescription.value) {
    const responce = await $dialogModal.value.open(TaskDialogEnum.CancelDescriptionChanges);
    if (!responce) {
      resetDescriptionEditMode();
    }
    return;
  }
  if (isEditMode.value) {
    resetDescriptionEditMode();
  }
};
/**Сброс режима редактировании описания */
const resetDescriptionEditMode = () => {
  descriptionIsEditMode.value = false;
  props.formData.Description = previousDescription.value;
};

// Функция возврата
const goBack = () => {
  if (router.options.history.state.back) {
    router.go(-1);
  } else {
    router.push({
      name: 'queue',
    });
  }
};

// Обработчик для кнопки "Назад" в браузере
const handlePopState = () => {
  goBack();
};

const parentScrollContainer: string = inject('parent-scroll-container');
const isShowFloatButton = ref<boolean>(false);

const checkScrollParentPosition = (e: Event) => {
  let parentContainerScrollTop: HTMLElement = e.target as HTMLElement;
  isShowFloatButton.value = parentContainerScrollTop.scrollTop > 470;
};
/**Закрыть оценку задачи */
const closeEstimate = () => {
  router.push({ name: 'projects' });
};

defineExpose({
  $editor,
  $taskRelations,
});

onMounted(() => {
  previousDescription.value = props.formData.Description;
  document
    .querySelector(parentScrollContainer)
    ?.addEventListener('scroll', checkScrollParentPosition);
});
onUnmounted(() => {
  document
    .querySelector(parentScrollContainer)
    ?.removeEventListener('scroll', checkScrollParentPosition);
});
</script>

<style lang="scss" scoped>
.task-main-detail {
  padding: 1.5rem 0.25rem 1.5rem 1.5rem;

  &__arrow-uturn-left-icon {
    min-width: 3rem !important;
  }
  &__scroll {
    max-height: calc(100vh - 20rem);
    padding-right: 1.25rem;
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
    margin-right: 1.25rem;

    &_estimate {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 3rem;
      gap: 1.5rem;
      font-size: 1.625rem;
      font-weight: 500;
      color: var(--text-secondary);
      &_close {
        width: 1.5rem;
        height: 1.5rem;
        color: var(--text-primary);
        cursor: pointer;
      }
    }
  }

  &__subheader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1.5rem;
    margin-right: 1.25rem;
  }

  &__subheader-info {
    display: flex;
    align-items: center;
  }

  &__subheader-left {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    gap: 0.625rem;
  }

  &__subheader-left,
  &__subheader-right {
    display: flex;
    align-items: center;
  }
  &__subheader-icon {
    color: var(--text-primary, #272d37);
  }
  &__subheader-fill-svg-icon {
    path {
      fill: var(--text-primary, #272d37);
    }
  }
  &__subheader-description {
    display: block;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
    color: var(--text-secondary, #686c73);
  }
  &__author {
    display: inline-flex;
    align-items: center;
    column-gap: 0.375rem;
    background-color: var(--neutral-translucent-10, #272d371a);
    border-radius: var(--6);
    padding: 0.25rem 1rem 0.25rem 0.75rem;
    margin-right: 0.625rem;
    cursor: pointer;
    &:not(.is-have-id) {
      padding-right: 0.75rem;
    }
  }
  &__author-id {
    color: var(--text-primary, #272d37);
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25rem;
  }
  &__title-icon {
    width: 1rem;
    height: 1rem;
  }
  &__subheader-divider {
    background-color: var(--neutral-30, #bfc0c3);
    height: 0.063rem;
    width: 100%;
    margin-top: 1.5rem;
  }
  &__input-wrap {
    margin: 1.5rem 0;
  }
  &__users {
    display: grid;
    grid-template-columns: 1fr 0.063rem 1fr;
    gap: 1.5rem;
    margin-top: 1.5rem;
  }
  &__users-divider {
    width: 0.063rem;
    height: 100%;
    background-color: var(--neutral-30, #bfc0c3);
  }
  &__subtasks {
    margin-top: 1.5rem;
  }

  &__count-subtasks {
    font-size: 0.875rem;
    color: var(--text-info, #2a77ef);
    line-height: 1.25rem;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  &__subtasks-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 0.25rem;

    &.is-empty {
      align-items: center;
      justify-content: flex-start;
    }
    &:not(.is-empty) {
      margin-bottom: 0.25rem;
    }
  }
  &__subtasks-label {
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
    color: var(--text-secondary, #686c73);
  }
  &__subtasks-content {
    display: flex;
    flex-direction: column;
    row-gap: 0.25rem;
  }

  &__editor-float-button {
    display: none;
    position: fixed;
    top: 3.75rem;
    right: 32.85rem;
  }
  &__editor-float-button--show {
    display: block;
  }
  &__editor {
    margin-top: 1.5rem;
  }
  &__files {
    margin-bottom: 0.875rem;
  }
  &__weeek-tag {
    margin-right: 0.625rem;
  }
}
</style>

<style lang="scss">
.task-main-detail {
  &__copy-button {
    .button__left-slot {
      min-width: 1rem;
    }
  }
  &__arrow-uturn-left-icon {
    min-width: 3rem;
    .button__left-slot {
      min-width: 1.5rem;
    }
  }

  &__editor {
    &.tir-pm-text-editor-file {
      max-width: 100%;
    }
  }
}
</style>
